import React, { memo } from "react";
import { Card, CardContent, type CardProps } from "@mui/material";

export interface SideBorderCardProps extends Omit<CardProps, "children"> {
  borderColor: string;
  children: React.ReactNode;
}

const SideBorderCard: React.FC<SideBorderCardProps> = memo(
  ({ borderColor, children, sx, ...cardProps }) => {
    return (
      <Card
        sx={{
          height: "100%",
          borderLeft: "4px solid",
          borderLeftColor: borderColor,
          borderRadius: "0 8px 8px 0",
          backgroundColor: "background.paper",
          ...sx,
        }}
        {...cardProps}
      >
        <CardContent>{children}</CardContent>
      </Card>
    );
  },
);

SideBorderCard.displayName = "SideBorderCard";

export default SideBorderCard;

